export const isValidEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return !emailRegex.test(email);
};

export const isBlockedDomain = (email) => {
  const blockedDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "yahoo.co.in",
    "aol.com",
    "live.com",
    "outlook.com",
  ];

  const domain = email.split("@")[1];
  return blockedDomains.includes(domain);
};
export const year = new Date().getFullYear();
